import { Typography } from "@mui/material";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";

const DateTime = ({ fontSize, receivedDateTime }) => {
  const { settings } = useUIBp();

  const parsedDate = receivedDateTime ? new Date(receivedDateTime) : null;
  const localDate =
    parsedDate && !isNaN(parsedDate.getTime())
      ? parsedDate.toLocaleString(settings.locale)
      : "";

  return <Typography {...{ fontSize }}>{localDate}</Typography>;
};

export default DateTime;
